import { Input } from "reactstrap";
import Select from 'react-select';
import { useRef } from "react";

function DropdownList(props: any) {
	const {
		id,
		name,
		placeholder,
		invalid,
		feedback,
		isDisabled,
		ismulti,
		escapeClearsValue,
		value,
		list,
		listkey,
		listvalue,
		maxheight,
		onChange,
		fieldReference,
		noAutoSelect,
		isClearable,
		...rest
	}: {
		id: any,
		name: string,
		invalid: boolean,
		feedback: string,
		isDisabled: boolean,
		ismulti: boolean,
		escapeClearsValue: any,
		value: string,
		list: any[],
		listkey: string,
		listvalue: string,
		maxheight: number,
		placeholder?: string
		onChange: Function,
		fieldReference: any,
		noAutoSelect: boolean,
		isClearable: boolean
		} = props

	const selectRef = useRef<any>(null);

	const getOptions = (list: any[], keyText: string, valueText: string) => {
		return list ? list.map((x) => ({ ...x, value: x[valueText], label: x[keyText] })) : [];
	}

	const getValue = (value:string, list:any[], isDisabled: boolean) => {
		if (list) {
			if (isDisabled && selectRef.current) {
				selectRef.current.blur();
			}
			return list.find((o) => o.value === value) || null;
		}
		return null;
	}

	const optionList = getOptions(list, listkey, listvalue);
	const autoSelectSingleOption = optionList.length === 1;
	const effectiveValue = autoSelectSingleOption ? optionList[0][listvalue] : value;

	let clearable = isClearable ?? true;
	let maxWidth = 200;

	if (list) {
		let width = listkey.length * 8;
		if (placeholder) {
			let placeholderWidth = placeholder.length * 10;
			width = width > placeholderWidth ? width : placeholderWidth;
		}

		list.forEach((x) => {
			if (width > maxWidth) {
				maxWidth = width;
			}
		})
	}

	const customStyles = {
		option: (provided:any) => ({ ...provided }),
		container: (provided:any) => ({
			...provided,
			borderColor: invalid ? '#dc3545' : 'hsl(0, 0%, 80%)',
			width: `${maxWidth}px`,
		}),
		control: (provided:any, state:any) => ({
			...provided,
			cursor: 'pointer',
			borderColor: invalid && !state.isFocused ? '#dc3545' : 'hsl(0, 0%, 80%)',
		}),
	}

	return (
		<>
			<Select
				ref={selectRef}
				styles={customStyles}
				name={name}
				value={getValue(effectiveValue, optionList, isDisabled)} /*className={classes}*/
				isDisabled={isDisabled || autoSelectSingleOption}
				escapeClearsValue={escapeClearsValue ? escapeClearsValue : true}
				isClearable={clearable}
				classNamePrefix="select" {...rest}
				placeholder={placeholder} isMulti={ismulti}
				onChange={(e) => onChange(name, e)}
				options={optionList}
				maxMenuHeight={maxheight}
				menuPlacement="auto"
			/>
			<Input type="hidden" invalid={invalid} />
			<div className="invalid-feedback">
				{feedback}
			</div>
		</>
	);
}
export default DropdownList;